import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { BsModalService } from "ngx-bootstrap/modal";

import { ModuleComponent } from '../module.component';
import { GuideService } from "../../services/guide.service";
import { ScrollToService } from "ng2-scroll-to-el";
import { IdentityService } from "../../../services/identity.service";
import { ToastrService } from "ngx-toastr";


@Component({
  templateUrl: './1C.component.html',
  styleUrls: ['../component.css']
})
export class _1CComponent extends ModuleComponent {

  C12: string = `<ol type="a"><li>Experience: </li><li>Education: </li><li>Training: </li><li>Credentials: </li></ol>`;
  C13: string = `<ol type="a"><li>Family: </li><li>Transportation: </li><li>Work: </li><li>Other situations: </li></ol>`;
  C22: string = `Some examples include Keyboarding, taking blood pressure, changing the oil in a car, or knowledge of Microsoft Office suite.`;
  C32: string = `<ol type="a"><li>Credentials: </li><li>Licenses: </li><li>Continuing education: </li><li>Stackable credentials: </li></ol>`;

  constructor(router: Router, guideService: GuideService, modalService: BsModalService, scrollService: ScrollToService, identitySrv: IdentityService, toastr: ToastrService) {
    super(router, scrollService, guideService, modalService, identitySrv, toastr);

    this.titles.push({
      "activityId": "C11",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about things to consider when planning for your career`
    });
    this.titles.push({
      "activityId": "C12",
      "html": `<i class="fas fa-sticky-note"></i> <strong>Review</strong> - What do you still need?`
    });
    this.titles.push({
      "activityId": "C13",
      "html": `<i class="fas fa-sticky-note"></i> <strong>Review</strong> What situations do you need to plan around?`
    });
    this.titles.push({
      "activityId": "C14",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for "Find places where staff can help you reach your goals"`
    });

    this.titles.push({
      "activityId": "C21",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about different ways to explore training programs`
    });
    this.titles.push({
      "activityId": "C22",
      "html": `<i class="fas fa-sticky-note"></i> <strong>Recognize</strong> the skills that can often transfer from one job to another`
    });
    this.titles.push({
      "activityId": "C23",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response - rate your employability skill level`
    });

    this.titles.push({
      "activityId": "C31",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> what are technical skills`
    });
    this.titles.push({
      "activityId": "C32",
      "html": `<i class="fas fa-sticky-note"></i> <strong>Identify</strong> industry wide technical skills required for the career pathway you selected`
    });
    this.titles.push({
      "activityId": "C33",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> this activity: Update your career plan dates for "Learn about credentials you can earn and how to get them"`
    });

    this.titles.push({
      "activityId": "C41",
      "html": `<i class="fas fa-file-import"></i><strong>Learn</strong> about setting your goals and create a plan`
    });
    this.titles.push({
      "activityId": "C42",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> this task: Create a goal(s) and step(s) related to career, training and skills needed.`
    });

    this.titles.push({
      "activityId": "C51",
      "html": `<i class="fas fa-file-import"></i> <strong>Test</strong> your knowledge of what you learned. These questions will be on the post-assessment test.`
    });


    this.group = 0;
    this.alpha = 'C';

    this.activeMod = { group: 0, alpha: 'C', number: 1 };
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    this.loadGuide();
  }

}
